import ApiServer from '@/utils/api/ApiServer.js'

export default {
  async fetchNotifications (context) {
    const response = await ApiServer.get('notifications')
    context.commit('setNotifications', response.data)
    return response.data
  }
}
